import { DefaultMethod } from "./common";

export class Creative {
  name: string;
  ad_type: 'banner' | 'video' | 'html5' | 'audio' | 'connected_tv' | 'native_banner' | 'native_video';
  selectVideoCrtv: boolean;
  width: number;
  height: number;
  language: number;
  line_items: Array<any>;
  segments: Array<any>;
  details: CreativeDetail;
  folder: number;
  third_party_pixels: Array<CreativePixel>;
  is_priority_audit:boolean;
  apnx_audit_feedback: string;
  adx_audit_feedback: string;
  is_coupon_creative: boolean;
  qr_position;
  accepted_outlets: Array<any>;
  selected_coupon_codes: Array<any>;

  constructor() {
    this.ad_type = 'banner';
    this.line_items = [];
    this.segments = [];
    this.third_party_pixels = [];
    this.details = new CreativeDetail();
    this.folder = 0;
    this.language = 1;
    this.is_priority_audit = false;
    this.apnx_audit_feedback = '';
    this.adx_audit_feedback = '';
    this.is_coupon_creative = false;
    this.qr_position = new CreativePosition ();
    this.accepted_outlets = [];
    this.selected_coupon_codes = [];
    this.selectVideoCrtv = false;
  }
}

export class CreativePosition{
  x_position;
  y_position;
  constructor() {
    this.x_position = 0;
    this.y_position = 0;
  }
}

export class DefaultCreative {
  ad_type: DefaultMethod
  folder_limit: DefaultMethod
  is_priority_audit: DefaultMethod
  third_party_pixels: DefaultMethod
  is_mobile_campaign: DefaultMethod
  constructor() {}
}

export class CreativePixel {
  format: 'image' | 'js' | 'html';
  url: string;
}

export class NativeAttributes {
  icon_url: string;
  image_url: string;
  title: string;
  description: string;
  sponsored_by: string;
  call_to_action: string;
  video_creative_ids: Array<any>;

  constructor() {
    this.description = '';
    this.video_creative_ids = []
  }
}

export interface SelectedVideoCreatives {
  videoCrtv: Array<any>;
  id;
}

export class CreativeDetail {
  landing_page: string;
  file_name: string;
  preview_url: string;
  s3_file_url: string;
  size_in_bytes: number;
  is_mobile_campaign: boolean;
  alternate_page: string;
  third_party_tag: string;
  end_point_url: string;
  is_whitelisted: boolean;
  s3_original_file_url: string;
  native_attributes: NativeAttributes;
  qr_placement: string;
  landing_page_crtv: string;

  constructor() {
    this.is_mobile_campaign = false;
    this.qr_placement = 'banner';
    this.native_attributes = new NativeAttributes();
  }
}

export const videoIframe = `
<html>
    <head>
        <style>
            .speaker span:after,.speaker span:before{content:'';position:absolute}body{margin:0}.speaker{height:30px;width:30px;position:absolute;overflow:hidden;display:inline-block;bottom:0;right:0;z-index:1111111}.speaker span{display:block;width:8px;height:8px;background:#fff;margin:11px 0 0 2px}.speaker span:after{width:0;height:0;border-style:solid;border-color:transparent #fff transparent transparent;border-width:10px 14px 10px 15px;left:-13px;top:5px}.speaker span:before{transform:rotate(45deg);border-radius:0 50px 0 0;width:5px;height:5px;border-style:double;border-color:#fff;border-width:7px 7px 0 0;left:18px;top:9px;transition:all .2s ease-out}.speaker:hover span:before{transform:scale(.8) translate(-3px,0) rotate(42deg)}.speaker.mute span:before{transform:scale(.5) translate(-15px,0) rotate(36deg);opacity:0}#playbutton{width:50px;top:40%;left:40%;position:absolute;z-index:1000;display:none}#playbutton:hover{cursor:pointer}
        </style>
    </head>
    <body>
        <div id="dw-adelement">
            <div id="mainContainer" style="width:300px;height:225px;position:relative;background:#000">
                <div id="content" style="width:300px;height:225px;position:absolute;top:0;left:0;">
                    <video autoplay="autoplay" controls="" controlslist="nodownload" id="contentElement" playsinline="" style="width:300px;height:225px">
                    </video>
                </div>
                <div id="adContainer" style="max-width:300px;max-height:225px;position:absolute;top:0;left:0;z-index:1;"></div>
                <span class="speaker mute" id="muteButton" style="display: none;">
                    <span></span>
                </span>
                 <span>
                    <img id="playbutton" src="https://contentvideo-zt3fn6v93n.stackpathdns.com/play.png">
                </span>
            </div>
        </div>
    <script>

      var urlPrefix  = window.location.protocol;
      var logEnabled = false;
      var samplePrerollVast =  "{video_tag}";
      var prerollRetryCount = 1;
      var sampleMidrollVast = "";
      var midrollLongOffset =  30000;
      var midrollShortOffset = 30000;
      var backupOffset = 30;
      var maxMidrollRetry =2;
      var tagId = 911;
      var trackingEnabled =  false;
      var isMute = false;
      var volume = "0.2";
      var isVideoMute = false;
      var videoContentArray = [{"url": "", "type": "video/mp4"},];

    </script>


    <script type="text/javascript" src="https://imasdk.googleapis.com/js/sdkloader/ima3.js"></script>
    <script src="https://adunits.datawrkz.com/production/content_video/src/v1.3.1/core.js"></script>
    </body>
</html>

`

export const QrPositions: Array<any> = [
  { value: "top_left", name: "Top Left" },
  { value: "top_right", name: "Top Right" },
  { value: "bottom_right", name: "Bottom Right" },
  { value: "bottom_left", name: "Bottom Left" },
  { value: "center", name: "Center" },
]

export const crtvTypeOptions = [
  { value: 'banner', label: 'Banner' },
  { value: 'video', label: 'Video' },
  { value: 'html5', label: 'HTML 5' },
  { value: 'audio', label: 'Audio' },
  { value: 'connected_tv', label: 'Connected TV' },
  { value: 'native_banner', label: 'Native Banner'},
  { value: 'native_video', label: 'Native Video'}
]

export const nativeAdTypes = ["native_banner", "native_video"];
export const adWithNoJsHtmlThirdPtyPixel = ["video", "audio", "connected_tv"];


export const qrPlacementTypes = [
  { value: "banner", label: "Banner" },
  { value: "website", label: "Website" },
];
